// extracted by mini-css-extract-plugin
module.exports = {"tags-list":"TagsRoll_tags-list__cnkFM","tags-item":"TagsRoll_tags-item__AMhL7","tags-item--last":"TagsRoll_tags-item--last__WvW0E","tags-link":"TagsRoll_tags-link__Y0_n6"};